import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'

// Styles
import classes from './Products.scss'

// Actions
import { productActions, orderActions, userActions } from 'redux/actionCreators'

// Components
import { ProductItem } from 'components'

// Helpers
import _get from 'lodash.get'
import _omitBy from 'lodash.omitby'
import _isNil from 'lodash.isnil'
import { offset } from 'helpers/utilities'

const titleMap = {
  'best-selling': 'สินค้าขายดี',
  'new': 'สินค้าใหม่',
  'promotion': 'สินค้าโปรโมชั่น (มีของแถม)',
  'back-in-stock': 'สินค้า Back in Stock'
}
@connect(state => ({
  cartProductMap: _get(state, ['order', 'cartProductMap']) || {},
  products: _get(state, ['product', 'homeProducts']) || [],
  productCode: _get(state, 'product.product.productCode') || '',
  userClass: _get(state, ['user', 'me', 'userClass']) || 0
}), (dispatch, ownProps) => ({
  attemptFindHomeProducts: (payload = {}) =>
    dispatch(productActions.attemptFindHomeProducts(_omitBy({
      ...payload,
      recommended: _get(ownProps, 'params.key') === 'best-selling' || undefined,
      promotional: _get(ownProps, 'params.key') === 'new' || undefined,
      withGiveaway: _get(ownProps, 'params.key') === 'promotion' || undefined,
      backInStock: _get(ownProps, 'params.key') === 'back-in-stock' || undefined,
      limit: 100
    }, _isNil))),
  attemptAddToCart: (payload) =>
    dispatch(orderActions.attemptAddToCart(payload)),
  attemptAddToWishlist: (productCode) =>
    dispatch(userActions.attemptAddToWishlist({ productCode })),
  attemptRemoveFromWishlist: (productCode) =>
    dispatch(userActions.attemptRemoveFromWishlist({ productCode }))
}))
class Products extends Component {
  static propTypes = {
    products: PropTypes.array.isRequired
  };

  constructor (props) {
    super(props)
    this.state = {}
  }

  componentDidMount () {
    window.objectFitImages()
    this.props.attemptFindHomeProducts()
    if (this.props.productCode) {
      setTimeout(() => {
        const row = document.getElementById(this.props.productCode)
        if (!row) return
        const { top } = offset(row)
        window.scrollTo(0, top - 200)
      }, 500)
    }
  }

  _renderProduct = (product) =>
    <div key={product.productCode} className={classes.productItemWrapper}>
      <ProductItem
        product={product}
        amount={_get(this.props, ['cartProductMap', product.productCode, 'amount'])}
        userClass={this.props.userClass}
        onAddToCart={this.props.attemptAddToCart}
        onAddToWishlist={this.props.attemptAddToWishlist}
        onRemoveFromWishlist={this.props.attemptRemoveFromWishlist} />
    </div>

  render () {
    const { products, params } = this.props
    return (
      <section className={classes.products}>
        <div className={classes.header}>
          <h2>{titleMap[_get(params, 'key')] || ''}</h2>
        </div>
        <div className={classes.productItemsContainer}>
          {products.map(this._renderProduct)}
        </div>
      </section>
    )
  }
}

export default Products



// WEBPACK FOOTER //
// ./src/containers/User/Home/Products.js